import {createFileRoute} from '@tanstack/react-router';

import {OrgProfilePage} from '@/modules/admin/pages/OrgProfilePage';

export const Route = createFileRoute('/_authenticated/admin/organization-profile/')({
  component: OrgProfilePage,
});
